/**
 * Helpers de fecha para toda la plataforma.
 *
 * Reglas:
 *  - Strings 'YYYY-MM-DD' (10 chars, sin hora) → parsear como fecha LOCAL
 *    del navegador (evita retroceso por interpretación UTC-00:00 en
 *    zonas oeste de Greenwich).
 *  - Strings con hora / ISO timestamp (incluyen T, Z u offset) → parsear
 *    normal (JS respeta la zona indicada) y formatear usando la zona
 *    local del navegador para respetar a usuarios que puedan estar
 *    viajando.
 */

export const parseFechaLima = (s) => {
  if (!s) return null;
  if (s instanceof Date) return s;
  if (typeof s !== 'string') return new Date(s);
  // Date-only (exactamente 'YYYY-MM-DD'): interpretar como local
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  // Timestamp con hora (T, Z, offset): ISO estándar, respeta la zona
  return new Date(s);
};

export const formatFechaLima = (
  s,
  opts = { day: '2-digit', month: 'short', year: 'numeric' },
) => {
  const dt = parseFechaLima(s);
  if (!dt || isNaN(dt.getTime())) return '';
  // Sin timeZone explícito: se usa la del navegador (respeta viajeros).
  return dt.toLocaleDateString('es-PE', opts);
};

export const formatFechaHoraLima = (
  s,
  opts = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  },
) => {
  const dt = parseFechaLima(s);
  if (!dt || isNaN(dt.getTime())) return '';
  return dt.toLocaleString('es-PE', opts);
};
